import { render, staticRenderFns } from "./Synchronization.vue?vue&type=template&id=b3a6cede&scoped=true&"
import script from "./Synchronization.vue?vue&type=script&lang=js&"
export * from "./Synchronization.vue?vue&type=script&lang=js&"
import style0 from "./Synchronization.vue?vue&type=style&index=0&id=b3a6cede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a6cede",
  null
  
)

export default component.exports